import { NumericTextBox } from '@syncfusion/ej2-inputs';
import { extend, isUndefined } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
/**
 * `numberfilterui` render number column.
 *
 * @hidden
 */
var NumberFilterUI = /** @class */ (function () {
    function NumberFilterUI(parent, serviceLocator, filterSettings) {
        this.filterSettings = filterSettings;
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        if (this.parent) {
            this.parent.on(events.filterMenuClose, this.destroy, this);
            this.parent.on(events.destroy, this.destroy, this);
        }
    }
    NumberFilterUI.prototype.keyEventHandler = function (args) {
        if (args.keyCode === 13 || args.keyCode === 9) {
            var evt = document.createEvent('HTMLEvents');
            evt.initEvent('change', false, true);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.dispatchEvent(evt);
        }
    };
    NumberFilterUI.prototype.create = function (args) {
        this.instance = this.parent.createElement('input', { className: 'e-flmenu-input', id: 'numberui-' + args.column.uid });
        args.target.appendChild(this.instance);
        this.numericTxtObj = new NumericTextBox(extend({
            format: typeof (args.column.format) === 'string' || isUndefined(args.column.format) ? args.column.format :
                args.column.format.format,
            locale: this.parent.locale,
            cssClass: this.parent.cssClass ? 'e-popup-flmenu' + ' ' + this.parent.cssClass : 'e-popup-flmenu',
            placeholder: args.localizeText.getConstant('EnterValue'),
            enableRtl: this.parent.enableRtl
        }, args.column.filter.params));
        this.numericTxtObj.appendTo(this.instance);
    };
    NumberFilterUI.prototype.write = function (args) {
        var numberuiObj = document.querySelector('#numberui-' + args.column.uid).ej2_instances[0];
        numberuiObj.element.addEventListener('keydown', this.keyEventHandler);
        numberuiObj.value = args.filteredValue;
    };
    NumberFilterUI.prototype.read = function (element, column, filterOptr, filterObj) {
        var numberuiObj = document.querySelector('#numberui-' + column.uid).ej2_instances[0];
        var filterValue = numberuiObj.value;
        filterObj.filterByColumn(column.field, filterOptr, filterValue, 'and', true);
    };
    NumberFilterUI.prototype.destroy = function () {
        this.parent.off(events.filterMenuClose, this.destroy);
        this.parent.off(events.destroy, this.destroy);
        if (!this.numericTxtObj || this.numericTxtObj.isDestroyed) {
            return;
        }
        this.numericTxtObj.destroy();
    };
    return NumberFilterUI;
}());
export { NumberFilterUI };
